import React, { useState, useEffect } from 'react';

interface ReadingRulerOverlayProps {
  enabled: boolean;
}

export const ReadingRulerOverlay: React.FC<ReadingRulerOverlayProps> = ({ enabled }) => {
  const [mouseY, setMouseY] = useState(250);
  const [rulerHeight, setRulerHeight] = useState(48);

  useEffect(() => {
    if (!enabled) return;

    const handleMouseMove = (e: MouseEvent) => {
      setMouseY(e.clientY);
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, [enabled]);

  if (!enabled) return null;

  return (
    <div 
      className="fixed inset-0 pointer-events-none z-[99999] overflow-hidden transition-opacity duration-300"
      aria-hidden="true"
    >
      {/* Upper Dimmed Backdrop */}
      <div 
        className="absolute top-0 left-0 right-0 bg-black/45 backdrop-blur-[0.5px] transition-all duration-75"
        style={{ height: `${Math.max(0, mouseY - rulerHeight / 2)}px` }}
      />

      {/* Focused Reading Highlight Band */}
      <div 
        className="absolute left-0 right-0 border-y-2 border-[#ffd64e] bg-[#ffd64e]/15 shadow-[0_0_20px_rgba(255,214,78,0.25)] transition-all duration-75 flex items-center justify-between px-6"
        style={{ 
          top: `${Math.max(0, mouseY - rulerHeight / 2)}px`, 
          height: `${rulerHeight}px` 
        }}
      >
        <span className="text-[10px] font-black uppercase tracking-widest text-[#1c1b1f] bg-[#ffd64e] px-2 py-0.5 rounded-full shadow-xs">
          📖 Dyslexia Reading Focus
        </span>
      </div>

      {/* Lower Dimmed Backdrop */}
      <div 
        className="absolute bottom-0 left-0 right-0 bg-black/45 backdrop-blur-[0.5px] transition-all duration-75"
        style={{ top: `${mouseY + rulerHeight / 2}px` }}
      />
    </div>
  );
};
